<template>
  <v-card flat tile>
    <v-container>
      <v-card-title class="pa-0 my-0" style="height: 80px">
        <v-btn @click="goBack()" icon>
          <v-icon v-text="$vuetify.icons.arrowLeft"></v-icon>
        </v-btn>
        <span class="title pl-2">{{vehicle.plate}}</span>
      </v-card-title>
      <person-info-card flat subheader="车主信息" :person="vehicle.owner || {}"></person-info-card>
      <v-subheader>账单记录</v-subheader>
      <l-data-card
        ref="billList"
        class="mb-5"
        flat
        :headers="billHeader"
        :get-data="getBillHistory"
        :auto-title="0"
        :auto-headers="0"
        auto-actions
        no-data-text="没有账单记录"
        hide-title-search
      >
        <template slot="item-action" slot-scope="{props}">
          <v-layout justify-center v-show="hasPayPermission">
            <v-btn color="primary" flat @click="goToBillDetails(props.item)">点击查看账单详情</v-btn>
          </v-layout>
        </template>
      </l-data-card>
      <v-divider></v-divider>
      <v-subheader>预约历史</v-subheader>
      <l-data-card
        ref="reservationList"
        class="mb-5"
        flat
        :headers="reservationHeaders"
        :get-data="getReservations"
        :auto-title="0"
        :auto-headers="0"
        auto-actions
        no-data-text="没有预约历史"
        hide-title-search
      ></l-data-card>
      <v-divider></v-divider>
<!--      <v-subheader>通行记录</v-subheader>-->
<!--      <l-data-card-->
<!--        class="mb-5"-->
<!--        flat-->
<!--        :headers="passHeaders"-->
<!--        :auto-title="0"-->
<!--        :auto-headers="0"-->
<!--        :get-data="getPassLogs"-->
<!--        auto-actions-->
<!--        hide-search-->
<!--        :init-pagination="{sortBy: 'passDatetime', descending: true}"-->
<!--        hide-title-search-->
<!--        no-data-text="没有通行记录"-->
<!--      ></l-data-card>-->
<!--      <v-divider></v-divider>-->
      <v-subheader>违章记录</v-subheader>
      <l-data-card
        class="mb-5"
        flat
        :get-data="getViolations"
        :headers="violationHeaders"
        :auto-title="0"
        :auto-headers="0"
        auto-actions
        hide-title-search
        :init-pagination="{sortBy: 'creationTime', descending: true}"
        no-data-text="没有违章记录"
      ></l-data-card>
    </v-container>
  </v-card>
</template>

<script>
import PersonInfoCard from '@/components/personInfoCard'
import LDataCard from '@/components/LDataCard'
import {Reservation, VIOLATION_STATUS_TEXT, BILL_STATUS_TEXT} from '@/object'
export default {
  name: 'vehicleDetails',
  components: {LDataCard, PersonInfoCard},
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },
  data: vm => ({
    passHeaders: [
      {text: '通行时间', value: 'passDatetime', align: 'left', placeholder: 'N/A'},
      {text: '停车场区', value: 'parkingLotName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '通行关口', value: 'controllerName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '是否放行', value: 'status', align: 'right', placeholder: 'N/A', f: v => v + '' === '1' ? '抬杆放行' : '禁止通行'},
      {text: '通行详情', value: 'details', align: 'right', placeholder: 'N/A', tooltip: true, maxWidth: '14em'}
    ],
    reservationHeaders: [
      {text: '开始时间', value: 'startDatetime', align: 'right', placeholder: 'N/A', f: v => vm.$L.time.stringify(v)},
      {text: '结束时间', value: 'endDatetime', align: 'right', placeholder: 'N/A', f: v => vm.$L.time.stringify(v)},
      {text: '来访人', value: 'visitorName', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '联系人', value: 'ownerName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '申请人', value: 'applicantName', align: 'right', placeholder: 'N/A', sortable: false}
    ],
    violationHeaders: [
      {text: '上报时间', value: 'creationTime', align: 'left', f: v => vm.$L.time.stringify(v)},
      {text: '违章区域', value: 'area', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '违章类型', value: 'typeName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '违章状态', value: 'status', align: 'right', placeholder: 'N/A', f: v => VIOLATION_STATUS_TEXT[v]}
    ],
    billHeader: [
      {text: '创建时间', value: 'creationTime', align: 'left', f: v => vm.$L.time.stringify(new Date(v))},
      {text: '账单状态', value: 'status', align: 'right', placeholder: 'N/A', f: v => BILL_STATUS_TEXT[v]},
      {text: '账单描述', value: 'description', align: 'right', placeholder: 'N/A'},
    ],
  }),
  computed: {
    hasPayPermission () {
      let permission = this.$store.state.login.permission
      if (permission.wechat === undefined) return false
      return permission.wechat.billDetail !== undefined
    }
  },
  async created () {
    let permission = await this.$store.dispatch('login/getPermission')
  },
  methods: {
    goToBillDetails (data) {
      this.$router.push({name: 'billDetailsWx',
        query: {
          billId: data.id
        }})
    },
    async getBillHistory ({pagination, sortStack, filter}) {
      let {items, amount} = await this.$store.dispatch('pay/getBillList', {
        pagination,
        sortStack,
        filter,
        search: {key: 'plate', value: this.vehicle.plate}
      })
      console.log(items)
      return {items, amount}
    },
    getReservations ({pagination, sortStack, filter}) {
      return this.$store.dispatch('reservation/getReservations', {
        pagination,
        sortStack,
        filter,
        locate: this.showReservationHistory ? 'history' : 'runtime',
        search: {key: 'plate', value: this.vehicle.plate}
      })
    },
    getPassLogs ({pagination, sortStack, filter}) {
      return this.$store.dispatch('pass/getLogs', {
        pagination,
        sortStack,
        filter,
        search: {key: 'plate', value: this.vehicle.plate}
      })
    },
    getViolations ({pagination, sortStack, filter}) {
      return this.$store.dispatch('violation/getEvents', {
        pagination,
        sortStack,
        filter,
        search: {key: 'plate', value: this.vehicle.plate}
      })
    },
    goReservation ({item}) {
      // this.$router.push({
      //   name: 'PersonalReservationDetailsWX',
      //   params: {
      //     plate: item.plate,
      //     item: item
      //   },
      //   query: {id: item.id}
      // })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
